<template>
  <div class="page">
    <div class="content">
      <van-row>
        <van-col span="18" offset="3">
          <deng></deng>
        </van-col>
      </van-row>

      <div class="m-top-15">
        <van-row>
          <van-col span="14" offset="5">
            <van-field
              v-model="userInfo.name"
              center
              clearable
              placeholder="请输入你的称呼"
              input-align="center"
              class="input-simple"
              :maxlength="charLimit"
            >
            </van-field>
          </van-col>
        </van-row>

        <van-row class="m-top-7">
          <van-col span="14" offset="5">
            <img
              class="img-btn"
              src="../assets/images/start_btn.png"
              @click="startTheJourney"
            />
          </van-col>
        </van-row>

        <van-row class="m-top-5" v-if="showPerfectDataBtn">
          <van-col span="14" offset="5">
            <img
              class="img-btn"
              src="../assets/images/perfect_data.png"
              @click="toResultPage"
            />
          </van-col>
        </van-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { Row, Col, Field, Toast } from "vant";
import Deng from "../components/deng";
export default {
  name: "Login",
  components: {
    [Deng.name]: Deng,
    [Row.name]: Row,
    [Col.name]: Col,
    [Field.name]: Field,
  },
  data() {
    return {
      charLimit: 16,
      showPerfectDataBtn: false,
      userInfo: {
        name: "",
      },
      customerInfo: {},
    };
  },
  computed: {
    ...mapGetters(["checkLogin", "getUserInfo", "getBusinessData"]),
  },
  methods: {
    ...mapMutations(["login", "logout", "setBusinessData"]),
    startTheJourney() {
      if (this.userInfo.name) {
        if (this.$api.getByteLen(this.userInfo.name) > this.charLimit) {
          Toast.fail("称呼不能大于16个字符！");
          return false;
        }

        this.login(this.userInfo);

        this.$api.doPost("/customer/updateCustomer", {
          nickName: this.userInfo.name,
        });

        this.$router.push("/loading");
      } else {
        Toast.fail("你的称呼不能为空！");
        return false;
      }
    },
    handlePrev() {
      let page = this.$route.query.page || "";
      let step = this.$route.query.step || 0;
      if (page && step) {
        this.$router.push("/" + page + "?step=" + step);
      } else {
        this.$router.push("/");
      }
    },
    toResultPage() {
      //let businessData = this.getBusinessData();
      if (!this.userInfo.name) {
        Toast.fail("称呼不能为空！");
        return false;
      }

      let cardParams = {
        index: this.customerInfo.serialNo || 1,
        head: this.customerInfo.headPic,
        nick: this.userInfo.name,
        tag: this.customerInfo.tagImage,
        tagimgs: this.customerInfo.tag,
        content: this.customerInfo.declaration,
      };

      // 落地页，先看之前有没有选过人，没选时，默认女生
      if (!this.getBusinessData("peopleImage")) {
        this.setBusinessData({ peopleImage: "one" });
      }

      this.$api
        .doPost("/customer/updateCustomer", { nickName: this.userInfo.name })
        .then((r) => {
          this.$api
            .doPost("/pic/card", cardParams)
            .then((res) => {
              this.$router.push("/introduce?step=24");
            })
            .catch(() => {
              this.$router.push("/introduce?step=24");
            });
        })
        .catch(() => {
          this.$router.push("/introduce?step=24");
        });
    },
  },
  created() {
    this.$emit("prev", true);

    this.userInfo = this.getUserInfo();

    this.$api.doPost("/customer/customerInfo").then((res) => {
      if (res.customerInfo) {
        this.customerInfo = res.customerInfo;

        this.userInfo.name = res.customerInfo.nickName;

        //台卡生成，并且保存了资料
        this.showPerfectDataBtn = res.customerInfo.decca;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.page {
  background: url("../assets/images/login_bg.jpg") no-repeat center top;
  background-size: cover;
  overflow: hidden;
}

.content {
  width: 100%;
  margin-top: 25%;

  .input-simple {
    -webkit-border-radius: 30px;
    -moz-border-radius: 30px;
    border-radius: 30px;
    text-align: center;
    font-size: 16px;
    height: 55px;
  }
}
</style>
